module.exports = __webpack_public_path__ + "static/media/11.78dc86af.jpg";